// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// FUNCTIONS
import is_new_creative from "../../../../hooks/is_new_creative";
import { createPreviewLink } from "../functions/createPreviewLink";
// CONTEXT
import { useUserState } from "../../../../contexts/user.context";
// TYPES
import { HandlePreviewButtonProps, StudioConfig } from "../types";
// CONFIGS
import studio_config from "../../../../configs/studio.json";
import config from "../../../../configs/config";

export function PreviewButton({ isTruncated, data }: HandlePreviewButtonProps) {
  const user = useUserState();
  const isNewCreative = is_new_creative();
  const studioConfig: StudioConfig = studio_config;
  const frameRatios = studioConfig.formats[data.metadata.format || "post"].media.frameRatios;

  const handlePreview = (e: React.MouseEvent<Element, MouseEvent> | undefined) => {
    (e?.currentTarget as HTMLButtonElement).blur();
    const aspectRatio = data.metadata.aspectRatio || "picnic";
    const matchedFrameRatio = frameRatios.findIndex((frameRatio: FrameRatio) => frameRatio.name === aspectRatio);
    const configuration = {
      analytics: {
        DISABLED: config.analytics.DISABLED,
      },
      preview: {
        URL: config.preview.URL,
      },
      s3: {
        BUCKET: config.s3.BUCKET,
        REGION: config.s3.REGION,
      },
      environment: config.environment,
      adSlot: {
        adSlotWidth: studioConfig.formats[data.metadata.format].media.frameRatios[matchedFrameRatio].adSlotWidth,
        adSlotHeight: studioConfig.formats[data.metadata.format].media.frameRatios[matchedFrameRatio].adSlotHeight,
      },
    };
    const previewLink = createPreviewLink(data, user, configuration);
    window.open(previewLink);
  };

  return <>{isTruncated ? <ComponentLibrary.PCIconButton icon={"eye"} title={"Preview"} utilityClasses={"b--black-20"} inlineStyles={{ height: "40px", width: "40px" }} clickHandler={handlePreview} /> : <ComponentLibrary.PCActionButton isDisabled={isNewCreative} text={"Preview"} iconLeft={"eye"} iconColor={"color-text-5"} textColor={"color-text-5"} color={""} clickHandler={handlePreview} />}</>;
}
